import type { RouteObject } from "react-router-dom";
import { abacusRoutes } from "./abacus";
import { adminRoute } from "./admin";
import { coreRoutes } from "./core";
import { developmentRoutes } from "./development";
import { errorRoutes } from "./error";
import { galileoRoutes } from "./galileo";
import { howToRoutes } from "./howto";

export { ROUTES } from "./constants";

export const routes: RouteObject[] = [
	...coreRoutes,
	...galileoRoutes,
	...abacusRoutes,
	...howToRoutes,
	adminRoute,
	...developmentRoutes,
	...errorRoutes,
];
